import {Component, input, model} from '@angular/core';
import {VulcanIconComponent} from '@eagle-i/vulcan-component-library';

@Component({
  selector: 'tgrid-sidebar-group',
  imports: [
    VulcanIconComponent,
  ],
  templateUrl: './sidebar-group.component.html',
  styleUrl: './sidebar-group.component.scss',
})
export class SidebarGroupComponent {

  public title = input.required<string>();
  public expanded = model(false);


  public toggleExpansion() {
    this.expanded.update((current) => {
      return !current;
    });
  }
}
